
var globals = {};

module.exports = globals;
